"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SingleSelectGeneralHandler", {
    enumerable: true,
    get: function() {
        return SingleSelectGeneralHandler;
    }
});
const _multiselectgeneralhandler = require("../multi-select/multi-select.general.handler");
let SingleSelectGeneralHandler = class SingleSelectGeneralHandler extends _multiselectgeneralhandler.MultiSelectGeneralHandler {
};
